module.exports = __webpack_public_path__ + "img/gartek-services-due-diligence-studies-risk.2574a22a.png";